<template>

    <v-card color="#f5f5f5" v-observe-visibility="visibilityChanged">

        <v-toolbar :extension-height="$vuetify.breakpoint.lgAndDown ? 150 : 62"
                   fixed light color="white">
            <v-btn icon @click.native="closeDialog" light>
                <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title v-if="selectedItem.id === 0">Add Offer</v-toolbar-title>
            <v-toolbar-title v-else>Calculate Offer Position {{selectedOfferPosition.id}} -
                {{selectedItem.offer_number}}
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-layout row wrap slot="extension">

                <v-flex xs12 lg6>
                    <v-layout>
                        <v-flex sm12 md2 pl-4 pa-2>
                            <v-text-field
                                    label="Position-ID"
                                    :value="selectedOfferPosition.id"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                        <v-flex sm12 md2 pl-4 pa-2>
                            <v-text-field
                                    v-if="selectedOfferPosition.inquiries_positions_id !== null && typeof selectedOfferPosition.inquiries_positions_id !== 'undefined'"
                                    label="Internal-Number"
                                    :value="selectedOfferPosition.inquiry_position.internal_number"
                                    readonly
                            ></v-text-field>
                            <v-text-field v-else
                                          label="Internal-Number"
                                          v-model="selectedOfferPosition.internal_number"
                                          :rules="internalNumberRule"
                            ></v-text-field>
                        </v-flex>

                        <v-flex sm12 md2 pl-4 pa-2>
                            <v-text-field
                                    label="Manufacturer"
                                    :value="selectedOfferPosition.product.manufacturer.name"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                        <v-flex sm12 md2 pl-4 pa-2>
                            <v-text-field
                                    label="Item-Number"
                                    :value="selectedOfferPosition.product.reference"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                        <v-flex sm12 md1 pl-4 pa-2>
                            <v-text-field
                                    label="Quantity"
                                    :value="selectedOfferPosition.quantity"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                        <v-flex sm12 md1 pl-4 pa-2>
                            <v-text-field
                                    label="Unit"
                                    value="PCS"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                    </v-layout>

                </v-flex>

                <v-flex xs12 lg6>
                    <v-layout row>
                        <v-flex sm12 md4 pl-4 pa-2>
                            <v-text-field
                                    :suffix="selectedItem.currency.name"
                                    label="Unit-Prov"
                                    :value="calculateUnitProv.price"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                        <v-flex sm12 md3 pl-4 pa-2>
                            <v-text-field
                                    suffix="%"
                                    label="Unit-Prov %"
                                    :value="calculateUnitProv.percent"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                        <v-flex sm12 md3 pl-4 pa-2>
                            <v-text-field
                                    :suffix="selectedItem.currency.name"
                                    label="Total-Prov"
                                    :value="calculateTotalProv.price"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                        <v-flex sm12 md3 pl-4 pa-2>
                            <v-text-field
                                    suffix="%"
                                    label="Total-Prov %"
                                    :value="calculateTotalProv.percent"
                                    readonly
                            ></v-text-field>
                        </v-flex>


                        <v-flex xs4 pl-4 pa-2>
                            <v-text-field
                                    :suffix="selectedItem.currency.name"
                                    label="Total Sales-Price"
                                    v-model="calculateTotalSalesPrice"
                                    readonly
                            ></v-text-field>
                        </v-flex>

                    </v-layout>

                </v-flex>

            </v-layout>

        </v-toolbar>

        <div v-show="$vuetify.breakpoint.lgAndDown" style="height: 96px"></div>

        <v-container fluid grid-list-md pt-5>

            <v-data-iterator v-if="!loadingSupplierOfferPositions"
                             :items="getSupplierOfferPositions"
                             :rows-per-page-items="rowsPerPageItems"
                             :pagination.sync="pagination"
                             content-tag="v-layout"
                             row
                             wrap
                             pt-5
            >
                <v-flex pt-5
                        slot="item"
                        slot-scope="props"
                        xs12
                        sm6
                        md3
                        lg2
                >
                    <v-hover>
                        <v-card @click.native="setSelectedSupplierOffer(props.item.id)" slot-scope="{ hover }"
                                :class="`elevation-${hover ? 4 : 1}`">
                            <v-card-title>
                                <v-menu
                                        transition="slide-y-transition"
                                        :nudge-bottom="20"
                                        :nudge-right="0"
                                        :nudge-left="0">
                                    <v-btn small @click="openBottomSheet($vuetify.breakpoint.mdAndDown)"
                                           id="menu-button"
                                           slot="activator"
                                           icon>

                                        <v-icon dark>more_vert</v-icon>
                                    </v-btn>
                                    <v-list v-show="$vuetify.breakpoint.lgAndUp">
                                        <v-list-tile @click.native="editSupplierOffer()">
                                            <v-list-tile-title>
                                                <v-icon color="primary">edit</v-icon>
                                            </v-list-tile-title>
                                        </v-list-tile>
                                        <v-list-tile @click.native="deleteSupplierOffer()">
                                            <v-list-tile-title>
                                                <v-icon color="red">delete</v-icon>
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                                <h4>{{ props.item.suppliers_offer.supplier.name }}</h4>
                                <v-spacer></v-spacer>
                                <v-icon v-if="getSelectedSupplierOfferPosition.id === props.item.id" color="success">
                                    check_circle
                                </v-icon>
                            </v-card-title>

                            <v-divider></v-divider>
                            <!--      <v-list dense>-->
                            <v-list dense>
                                <v-list-tile>
                                    <v-list-tile-content>Unit Price:</v-list-tile-content>
                                    <v-list-tile-content v-if="getSelectedSupplierOfferPosition.id === props.item.id"
                                                         class="align-end"><b>{{
                                        calculateSupplierOfferUnitPriceMethod(props.item) }} {{
                                        props.item.suppliers_offer.currency.name }}</b>
                                    </v-list-tile-content>
                                    <v-list-tile-content v-else class="align-end">
                                        {{calculateSupplierOfferUnitPriceMethod(props.item) }} {{
                                        props.item.suppliers_offer.currency.name }}
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content>Delivery Time:</v-list-tile-content>
                                    <v-list-tile-content v-if="getSelectedSupplierOfferPosition.id === props.item.id"
                                                         class="align-end"><b>{{ props.item.delivery_time.value }} {{
                                        props.item.delivery_time.delivery_times_type.name }}</b>
                                    </v-list-tile-content>
                                    <v-list-tile-content v-else class="align-end">{{ props.item.delivery_time.value }}
                                        {{
                                        props.item.delivery_time.delivery_times_type.name }}
                                    </v-list-tile-content>
                                </v-list-tile>

                                <v-list-tile>
                                    <v-list-tile-content>Payment Term:</v-list-tile-content>
                                    <v-list-tile-content v-if="getSelectedSupplierOfferPosition.id === props.item.id"
                                                         class="align-end"><b>{{
                                        props.item.suppliers_offer.terms_of_payment.description }}</b>
                                    </v-list-tile-content>
                                    <v-list-tile-content v-else class="align-end">{{
                                        props.item.suppliers_offer.terms_of_payment.description }}
                                    </v-list-tile-content>
                                </v-list-tile>


                                <v-list-tile>
                                    <v-list-tile-content>Valid Until:</v-list-tile-content>
                                    <v-list-tile-content v-if="getSelectedSupplierOfferPosition.id === props.item.id"
                                                         class="align-end"><b>{{
                                        props.item.suppliers_offer.valid_until | toDateOnly }}</b>
                                    </v-list-tile-content>
                                    <v-list-tile-content v-else class="align-end">{{
                                        props.item.suppliers_offer.valid_until | toDateOnly }}
                                    </v-list-tile-content>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-list-tile-content>Supplier Offer:</v-list-tile-content>
                                    <v-list-tile-content class="align-end">
                                        <v-btn flat fab small class="pdfbutton"
                                               :loading="getLoadingDocumentToken(props.item.suppliers_offer.id)"
                                               @click="generateDocumentToken(props.item.suppliers_offer)"
                                        >
                                            <v-icon
                                                    size="20" color="secondary"

                                            >fal fa-file-pdf
                                            </v-icon>
                                        </v-btn>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </v-list>
                        </v-card>

                    </v-hover>
                </v-flex>
                <template v-slot:footer>
                    <v-toolbar flat>
                        <v-toolbar-title></v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon color="secondary darken-1"
                               @click.native="openAddSupplierDialog()">
                            <v-icon>add</v-icon>
                        </v-btn>
                    </v-toolbar>
                </template>
            </v-data-iterator>

            <v-container v-if="loadingSupplierOfferPositions"
                         pt-5>
                <v-layout row wrap align-center
                          pt-5>
                    <v-flex class="text-xs-center">
                        <v-progress-circular
                                :size="60"
                                color="primary"
                                indeterminate
                        ></v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-container>
        <v-form ref="form" v-model="saveCalculationValidation" lazy-validation>
            <v-layout row wrap>
                <v-flex pl-4 pr-4>
                    <v-divider></v-divider>

                    <v-layout row wrap>
                        <v-flex xs12 md4 pl-4 pt-4 pa-2>
                            <v-card>
                                <v-card-title><h4>Descriptions / Remark</h4></v-card-title>
                                <v-divider></v-divider>

                                <v-layout row wrap v-if="getSelectedSupplierOfferPosition.id === 0">
                                    <v-flex xs12 pa-5>
                                        <h3 class="text-xs-center">Please select a supplier offer first!</h3>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap pt-4 v-if="getSelectedSupplierOfferPosition.id !== 0">
                                    <v-flex xs12 pl-4 pr-4>
                                        <v-textarea
                                                v-if="selectedOfferPosition.inquiries_positions_id === null || typeof selectedOfferPosition.inquiries_positions_id === 'undefined'"
                                                v-model="selectedOfferPosition.customer_description"
                                                auto-grow
                                                rows="4"
                                                label="Customer Description"
                                                box
                                        ></v-textarea>
                                        <v-textarea v-else
                                                    v-model="selectedOfferPosition.inquiry_position.customer_description"
                                                    auto-grow
                                                    label="Customer Description"
                                                    readonly
                                        ></v-textarea>
                                    </v-flex>
                                    <v-flex xs12 pl-4 pr-4>
                                        <v-textarea
                                                :value="getSelectedSupplierOfferPosition.product.product_description.description"
                                                auto-grow
                                                label="Product Description"
                                                readonly
                                        ></v-textarea>
                                    </v-flex>

                                    <v-flex xs12 pl-4 pr-4>
                                        <v-textarea
                                                v-show="getSelectedSupplierOfferPosition.remark !== null"
                                                :value="getSelectedSupplierOfferPosition.remark"
                                                auto-grow
                                                label="Supplier Offer Remark"
                                                readonly
                                        ></v-textarea>
                                    </v-flex>
                                    <v-flex xs12 pl-4 pr-4>
                                        <v-textarea
                                                auto-grow
                                                rows="4"
                                                label="Offer Description"
                                                box
                                                v-model="selectedOfferPosition.description"
                                                :rules="offerTextRules"
                                        ></v-textarea>
                                    </v-flex>
                                    <v-flex xs12 pl-4 pr-4>
                                        <v-textarea
                                                auto-grow
                                                rows="4"
                                                label="Offer Remark"
                                                box
                                                v-model="selectedOfferPosition.remark"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>

                        <v-flex xs12 md8 pl-4 pt-4 pa-2 pb-5>
                            <v-card>
                                <v-card-title><h4>Calculation</h4></v-card-title>
                                <v-divider></v-divider>

                                <v-layout row wrap v-if="getSelectedSupplierOfferPosition.id === 0">
                                    <v-flex xs12 pa-5>
                                        <h3 class="text-xs-center">Please select a supplier offer first!</h3>
                                    </v-flex>
                                </v-layout>

                                <v-layout v-if="getSelectedSupplierOfferPosition.id !== 0" row wrap pt-4 pr-4 pl-4>


                                    <v-flex xs12 md3 pl-4 pr-4>
                                        <v-text-field
                                                :suffix="getSelectedSupplierOfferPosition.suppliers_offer.currency.name"
                                                label="Purchase Unit-Price"
                                                :value="calculateSupplierOfferUnitPriceFormatted"
                                                readonly
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md2 pl-4 pr-4>
                                        <v-text-field v-if="needExchange"
                                                      :suffix="selectedItem.currency.name"
                                                      label="Exchange Rate"
                                                      :value="getExchangeRate"
                                                      readonly
                                                      :loading="loading"
                                                      type="number"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md3 pl-4 pr-4>

                                        <v-text-field v-if="needExchange"
                                                      :suffix="selectedItem.currency.name"
                                                      label="Purchase Unit-Price Exchange"
                                                      :value="calculateExchangePurchasePrice"
                                                      readonly
                                                      :loading="loading"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md2 pl-4 pr-4>
                                        <v-text-field
                                                label="Delivery Time"
                                                v-model="selectedOfferPosition.delivery_time.value"
                                                type="number"
                                                step=".01"
                                                min="0"
                                                box
                                        ></v-text-field>

                                    </v-flex>

                                    <v-flex xs12 md2 pl-4 pr-4>
                                        <v-autocomplete
                                                clearable
                                                v-model="selectedOfferPosition.delivery_time.delivery_times_types_id"
                                                :items="getDeliveryTimeTypes"
                                                label="Type"
                                                item-value="id"
                                                item-text="name"
                                                box
                                        ></v-autocomplete>
                                    </v-flex>
                                </v-layout>

                                <v-layout v-if="getSelectedSupplierOfferPosition.id !== 0" row wrap pr-4 pl-4>

                                    <v-flex xs12 md3 pl-4 pr-4>
                                        <v-text-field
                                                suffix="%"
                                                label="Margin"
                                                v-model="selectedOfferPosition.margin"
                                                type="number"
                                                step=".01"
                                                min="0.01"
                                                max="1"
                                                box
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md2 pl-4 pr-4>

                                        <v-text-field
                                                :suffix="selectedItem.currency.name"
                                                label="Margin"
                                                :value="calculateCurrencyMargin"
                                                readonly
                                                :loading="loading"
                                        ></v-text-field>

                                    </v-flex>
    <!--                                <v-flex xs12 md4 pl-4 pr-4>

                                    </v-flex>
                                    <v-flex xs12 pl-4 pr-4>

                                    </v-flex>-->


                                  <v-flex xs12 md3 pl-4 pr-4>

                                    <v-text-field
                                      :suffix="selectedItem.currency.name"
                                      label="Unit Purchase inc.(procurement costs)"
                                      :value="calculateSupplierOfferUnitSalesPriceWithACFormatted"
                                      readonly
                                      :loading="loading"
                                    />


                                  </v-flex>
                                  <v-flex xs12 md4 pl-4 pr-4>
                                    <v-text-field
                                      :suffix="selectedItem.currency.name"
                                      label="Unit Real Margin"
                                      :value="calculateRealCurrencyMargin"
                                      readonly
                                      :loading="loading"
                                    />
                                  </v-flex>

                                </v-layout>


                                <v-flex pb-2>

                                    <!--          TODO - move Additional Costs to component-->
                                    <v-layout row wrap pr-5 pl-5 v-if="getSelectedSupplierOfferPosition.id !== 0">
                                        <v-flex xs12 pt-2>
                                            <v-layout wrap>
                                                <v-subheader>Additional Costs</v-subheader>
                                                <v-spacer></v-spacer>
                                                <v-btn icon color="secondary darken-1"
                                                       @click.native="addOfferPositionAddCosts()">
                                                    <v-icon>add</v-icon>
                                                </v-btn>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex xs12 pb-2>
                                            <v-divider></v-divider>
                                        </v-flex>


                                        <v-flex xs12 pl-3 pr-3>
                                            <v-layout wrap>
                                                <template
                                                        v-for="(item, index) in selectedOfferPosition.customers_offers_positions_additional_costs">
                                                    <v-card-text>
                                                        <v-layout wrap pb-2>
                                                            <v-flex xs12 md2 pl-4 pr-4>

                                                                <v-text-field v-if="item.type === 'fixed'"
                                                                              :suffix="selectedItem.currency.name"
                                                                              label="Cost"
                                                                              v-model="item.value"
                                                                              type="number"
                                                                              step=".01"
                                                                              min="0"
                                                                ></v-text-field>

                                                                <v-text-field v-if="item.type !== 'fixed'"
                                                                              suffix="%"
                                                                              label="Cost"
                                                                              v-model="item.value"
                                                                              type="number"
                                                                              step=".01"
                                                                              min="0"
                                                                              max="100"
                                                                ></v-text-field>

                                                            </v-flex>

                                                            <v-flex xs12 md6 pl-4 pr-4>
                                                                <v-textarea
                                                                        auto-grow
                                                                        rows="1"
                                                                        label="Cost description"
                                                                        v-model="item.description"
                                                                        counter
                                                                        maxlength="255"
                                                                ></v-textarea>
                                                            </v-flex>

                                                            <v-flex xs8 md3 pl-4 pr-4>
                                                                <v-autocomplete
                                                                        clearable
                                                                        v-model="item.type"
                                                                        :items="additionalCostTypes"
                                                                        label="Type"
                                                                ></v-autocomplete>

                                                            </v-flex>

                                                            <v-spacer></v-spacer>
                                                            <v-btn :loading="getRemovingOfferPositionAddCosts(index)"
                                                                   icon ripple
                                                                   @click.native="removeOfferPositionAddCost(index)">
                                                                <v-icon color="red lighten-1">delete</v-icon>
                                                            </v-btn>
                                                        </v-layout>
                                                        <v-divider></v-divider>
                                                    </v-card-text>
                                                </template>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <!--          TODO - move Sales Commissions Costs to component-->
                                    <v-layout row wrap pt-2 pr-5 pl-5 v-if="getSelectedSupplierOfferPosition.id !== 0">
                                        <v-flex xs12 pt-2>
                                            <v-layout wrap>
                                                <v-subheader>Sales Commissions</v-subheader>
                                                <v-spacer></v-spacer>
                                                <v-btn icon color="secondary darken-1"
                                                       @click.native="addOfferPositionSalesCommissions()">
                                                    <v-icon>add</v-icon>
                                                </v-btn>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex xs12 pb-2>
                                            <v-divider></v-divider>
                                        </v-flex>


                                        <v-flex xs12 pl-3 pr-3>
                                            <v-layout wrap>
                                                <template
                                                        v-for="(item, index) in selectedOfferPosition.customers_offers_positions_commissions">
                                                    <v-card-text>
                                                        <v-layout wrap pb-2>
                                                            <v-flex xs12 md2 pl-4 pr-4>

                                                                <v-text-field
                                                                        suffix="%"
                                                                        label="Commission"
                                                                        v-model="item.value"
                                                                        type="number"
                                                                        step=".01"
                                                                        min="0"
                                                                        max="100"
                                                                ></v-text-field>

                                                            </v-flex>

                                                            <v-flex xs12 md6 pl-4 pr-4>
                                                                <v-autocomplete
                                                                        clearable
                                                                        v-model="item.accounts_id"
                                                                        :items="allAccounts"
                                                                        label="Account"
                                                                        item-value="id"
                                                                        :filter="customContactFilter"
                                                                >
                                                                    <template slot="item" slot-scope="data">
                                                                        <v-list-tile-content>
                                                                            <v-list-tile-title>
                                                                                {{ data.item.title ? data.item.title :
                                                                                '' }}
                                                                                {{
                                                                                data.item.firstname }} {{
                                                                                data.item.lastname }}
                                                                            </v-list-tile-title>
                                                                        </v-list-tile-content>
                                                                    </template>

                                                                    <template slot="selection" slot-scope="data">
                                                                        {{ data.item.firstname }} {{ data.item.lastname
                                                                        }}
                                                                    </template>

                                                                    <template slot="no-data">
                                                                        <v-layout wrap>
                                                                            <v-flex xs12 pl-4 pr-4>
                                                                                <v-btn @click.native="" block
                                                                                       small flat color="secondary">
                                                                                    Create
                                                                                    New Account
                                                                                    <v-icon>add</v-icon>
                                                                                </v-btn>
                                                                            </v-flex>
                                                                        </v-layout>
                                                                    </template>
                                                                </v-autocomplete>
                                                            </v-flex>

                                                            <v-flex xs8 md3 pl-4 pr-4>
                                                                <v-autocomplete
                                                                        clearable
                                                                        v-model="item.type"
                                                                        :items="discountTypes"
                                                                        label="Type"
                                                                ></v-autocomplete>

                                                            </v-flex>

                                                            <v-spacer></v-spacer>
                                                            <v-btn :loading="getRemovingOfferPositionSalesCommission(index)"
                                                                   icon ripple
                                                                   @click.native="removeOfferPositionSalesCommission(index)">
                                                                <v-icon color="red lighten-1">delete</v-icon>
                                                            </v-btn>
                                                        </v-layout>
                                                        <v-divider></v-divider>
                                                    </v-card-text>
                                                </template>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <!--          TODO - move Discounts Costs to component-->
                                    <v-layout row wrap pt-2 pr-5 pl-5 v-if="getSelectedSupplierOfferPosition.id !== 0">
                                        <v-flex xs12 pt-2>
                                            <v-layout wrap>
                                                <v-subheader>Discounts</v-subheader>
                                                <v-spacer></v-spacer>
                                                <v-btn icon color="secondary darken-1"
                                                       @click.native="addOfferPositionDiscount()">
                                                    <v-icon>add</v-icon>
                                                </v-btn>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex xs12 pb-2>
                                            <v-divider></v-divider>
                                        </v-flex>


                                        <v-flex xs12 pl-3 pr-3>
                                            <v-layout wrap>
                                                <template
                                                        v-for="(item, index) in selectedOfferPosition.customers_offers_positions_discounts">
                                                    <v-card-text>
                                                        <v-layout wrap pb-2>
                                                            <v-flex xs12 md2 pl-4 pr-4>

                                                                <v-text-field
                                                                        suffix="%"
                                                                        label="Discount"
                                                                        v-model="item.value"
                                                                        type="number"
                                                                        step=".01"
                                                                        min="0"
                                                                        max="100"
                                                                ></v-text-field>

                                                            </v-flex>

                                                            <v-flex xs12 md6 pl-4 pr-4>
                                                                <v-textarea
                                                                        auto-grow
                                                                        rows="1"
                                                                        label="Discount description"
                                                                        v-model="item.description"
                                                                        counter
                                                                        maxlength="255"
                                                                ></v-textarea>
                                                            </v-flex>

                                                            <v-flex xs8 md3 pl-4 pr-4>
                                                                <v-autocomplete
                                                                        clearable
                                                                        v-model="item.type"
                                                                        :items="discountTypes"
                                                                        label="Type"
                                                                ></v-autocomplete>

                                                            </v-flex>

                                                            <v-spacer></v-spacer>
                                                            <v-btn :loading="getRemovingOfferPositionDiscount(index)"
                                                                   icon ripple
                                                                   @click.native="removeOfferPositionDiscount(index)">
                                                                <v-icon color="red lighten-1">delete</v-icon>
                                                            </v-btn>
                                                        </v-layout>
                                                        <v-divider></v-divider>
                                                    </v-card-text>
                                                </template>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>

                                </v-flex>

                                <v-flex pb-1>
                                    <!--          TODO - move Additional Costs to component-->
                                    <v-layout row wrap pt-2 pr-5 pl-5 v-if="getSelectedSupplierOfferPosition.id !== 0">
                                        <v-flex xs12 pt-2>
                                            <v-layout wrap>
                                                <v-subheader>Sales Price</v-subheader>
                                                <v-spacer></v-spacer>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex xs12 pb-4>
                                            <v-divider></v-divider>
                                        </v-flex>


                                        <v-flex xs12 md3 pl-4 pr-4>
                                            <v-text-field
                                                    :suffix="selectedItem.currency.name"
                                                    label="Unit Sales-Price"
                                                    v-model="calculateSupplierOfferUnitSalesPriceFormatted"
                                                    readonly
                                            ></v-text-field>
                                        </v-flex>


                                        <v-flex xs12 md3 pl-4 pr-4>
                                            <v-text-field
                                                    label="Quantity"
                                                    v-model="selectedOfferPosition.quantity"
                                                    box
                                                    type="number"
                                                    min="1"
                                            ></v-text-field>
                                        </v-flex>

                                        <v-flex xs12 md3 pl-4 pr-4>
                                            <v-text-field
                                                    :suffix="selectedItem.currency.name"
                                                    label="Total Sales-Price"
                                                    v-model="calculateTotalSalesPrice"
                                                    readonly
                                            ></v-text-field>
                                        </v-flex>

                                    </v-layout>

                                </v-flex>
                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn :loading="loading"
                                           :disabled="!saveCalculationValidation || getSelectedSupplierOfferPosition.id === 0"
                                           color="secondary" @click.native="saveCalculation()">SAVE
                                        CALCULATION
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>

                </v-flex>

            </v-layout>
        </v-form>

        <AddSupplierDialog></AddSupplierDialog>

    </v-card>

</template>

<script>
    import {
        Settings,
        Offer,
        OfferPosition,
        SupplierOffers,
        SupplierOfferPositions
    } from '../../../store/namespace-helper'

    import {API_URL} from '../../../store/index'

    import DatetimePicker from '../../Shared/DatetimePicker.vue'
    import AddSupplierDialog from '../../SupplierOffers/AddSupplierOfferDialog.vue'
    import {in$, $} from 'moneysafe'
    import {$$, subtractPercent, addPercent} from 'moneysafe/ledger'

    import moment from 'moment'

    /*   import _ from 'lodash' */

    export default {
      components: {
        DatetimePicker,
        AddSupplierDialog
      },
      name: 'CalculateOfferPosition',
      data () {
        return {
          isVisible: false,
          rowsPerPageItems: [6, 8, 12],
          pagination: {
            rowsPerPage: 6
          },
          selectedSupplierOffer: 0,
          indexOfferPositionDiscountToDelete: 0,
          indexOfferPositionAddCostsToDelete: 0,
          indexOfferPositionSalesCommissionToDelete: 0,
          discountTypes: ['percent'],
          additionalCostTypes: ['percent', 'fixed'],
          allAccounts: [],
          loadingOfferForId: false,
          saveCalculationValidation: false,
          offerTextRules: [
            v => !!v || 'Offer Description is required',
            v => (v ? (v.length >= 10) : false) || 'Offer Description must be more than 10 characters'
          ],
          internalNumberRule: [
            v => !!v || ''
          ]

        }
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab visible, load data')
              this.loadCurrencies()
              this.loadTermsOfDeliveries()
              this.loadTermsOfPayments()
              this.loadSupplierOffers()
              this.loadDeliveryTimeTypes()
              this.loadAllAccounts()
              this.$refs.form.reset()
            } else {

            }
          }
        },
        getPDF () {
          let link = document.createElement('a')

          link.href = API_URL + '/documentStore/' + this.getDocumentViewToken.token
          link.target = '_blank'
          link.rel = 'noopener noreferrer'
          link.click()
        },
        generateDocumentToken (supplierOffer) {
          this.loadingOfferForId = supplierOffer.id
          this.$store.dispatch(SupplierOffers.actions.getDocumentViewTokenBySupplierOfferId, {
            id: supplierOffer.id,
            filename: supplierOffer.offer_number + '.pdf'
          }).then(response => {
            this.getPDF()
            this.loadingOfferForId = false
          })
        },
        closeDialog () {
          this.$store.dispatch(OfferPosition.actions.setSelectedOfferPosition, null)
          this.$store.dispatch(SupplierOfferPositions.actions.setSelectedSupplierOfferPosition, null)
          this.$store.dispatch(OfferPosition.actions.openCloseCalculateDialog)
        },
        loadCurrencies () {
          this.$store.dispatch(Settings.actions.loadAllCurrencies)
        },
        loadCurrencyExchangeRate () {
          this.$store.dispatch(Settings.actions.loadExchangeRate, this.getSelectedSupplierOfferPosition.suppliers_offer.currency.name)
        },
        loadTermsOfPayments () {
          this.$store.dispatch(Settings.actions.loadTermsOfPayments)
        },
        loadTermsOfDeliveries () {
          this.$store.dispatch(Settings.actions.loadTermsOfDeliveries)
        },
        loadSupplierOffers () {
          this.$store.dispatch(SupplierOfferPositions.actions.loadSupplierOfferPositionByProductID, this.selectedOfferPosition.products_id).then(response => {
            this.setSelectedSupplierOffer(this.selectedOfferPosition.suppliers_offers_positions_id)
          })
        },
        loadDeliveryTimeTypes () {
          this.$store.dispatch(Settings.actions.loadAllDeliveryTimeTypes)
        },
        saveCalculation () {
          if (!this.$refs.form.validate()) {
            return
          }
          this.selectedOfferPosition.suppliers_offers_positions_id = this.getSelectedSupplierOfferPosition.id
          this.$store.dispatch(OfferPosition.actions.saveOfferPosition, this.selectedOfferPosition)
        },
        setSelectedSupplierOffer (val) {
          this.$refs.form.validate()
          this.saveCalculationValidation = false
          let item = this.getSupplierOfferPositions.find(x => x.id === val)
          if (item !== null && typeof item !== 'undefined') {
            this.$store.dispatch(SupplierOfferPositions.actions.setSelectedSupplierOfferPosition, item)
            this.$store.dispatch(SupplierOffers.actions.setSelectedSupplierOffer, item.suppliers_offer)

            if (typeof this.selectedOfferPosition.delivery_time.id === 'undefined') {
              this.selectedOfferPosition.delivery_time.id = 0
            }
            if (this.getSelectedSupplierOfferPosition.delivery_time.delivery_times_type.id === 1) {
              this.selectedOfferPosition.delivery_time.value = this.getSelectedSupplierOfferPosition.delivery_time.value + 10
              this.selectedOfferPosition.delivery_time.delivery_times_types_id = this.getSelectedSupplierOfferPosition.delivery_time.delivery_times_type.id
            } else if (this.getSelectedSupplierOfferPosition.delivery_time.delivery_times_type.id === 2) {
              this.selectedOfferPosition.delivery_time.value = this.getSelectedSupplierOfferPosition.delivery_time.value + 2
              this.selectedOfferPosition.delivery_time.delivery_times_types_id = this.getSelectedSupplierOfferPosition.delivery_time.delivery_times_type.id
            } else if (this.getSelectedSupplierOfferPosition.delivery_time.delivery_times_type.id === 3) {
              this.selectedOfferPosition.delivery_time.value = this.getSelectedSupplierOfferPosition.delivery_time.value + 1
              this.selectedOfferPosition.delivery_time.delivery_times_types_id = this.getSelectedSupplierOfferPosition.delivery_time.delivery_times_type.id
            }

            this.loadCurrencyExchangeRate()
          }
        },
        addOfferPositionAddCosts () {
          this.selectedOfferPosition.customers_offers_positions_additional_costs.push({
            id: 0,
            customers_offers_positions_id: 0,
            value: 0.00,
            type: 'percent'
          })
        },
        addOfferPositionSalesCommissions () {
          this.selectedOfferPosition.customers_offers_positions_commissions.push({
            id: 0,
            customers_offers_positions_id: 0,
            value: 0.00,
            type: 'percent'
          })
        },
        addOfferPositionDiscount () {
          this.selectedOfferPosition.customers_offers_positions_discounts.push({
            id: 0,
            customers_offers_position_id: 0,
            value: 0.00,
            type: 'percent'
          })
        },
        removeOfferPositionAddCost (index) {
          this.indexOfferPositionAddCostsToDelete = index
          let id = this.selectedOfferPosition.customers_offers_positions_additional_costs[index].id

          if (id === 0) {
            this.selectedOfferPosition.customers_offers_positions_additional_costs.splice(index, 1)
          } else {
            this.$store.dispatch(OfferPosition.actions.removeOfferPositionAddCosts, id).then(response => {
              this.selectedOfferPosition.customers_offers_positions_additional_costs.splice(index, 1)
            })
          }
        },
        removeOfferPositionSalesCommission (index) {
          this.indexOfferPositionSalesCommissionToDelete = index
          let id = this.selectedOfferPosition.customers_offers_positions_commissions[index].id

          if (id === 0) {
            this.selectedOfferPosition.customers_offers_positions_commissions.splice(index, 1)
          } else {
            this.$store.dispatch(OfferPosition.actions.removeOfferPositionCommission, id).then(response => {
              this.selectedOfferPosition.customers_offers_positions_commissions.splice(index, 1)
            })
          }
        },
        removeOfferPositionDiscount (index) {
          this.indexOfferPositionDiscountToDelete = index
          let id = this.selectedOfferPosition.customers_offers_positions_discounts[index].id

          if (id === 0) {
            this.selectedOfferPosition.customers_offers_positions_discounts.splice(index, 1)
          } else {
            this.$store.dispatch(OfferPosition.actions.removeOfferPositionDiscount, id).then(response => {
              this.selectedOfferPosition.customers_offers_positions_discounts.splice(index, 1)
            })
          }
        },
        getRemovingOfferPositionAddCosts (val) {
          if (this.indexOfferPositionAddCostsToDelete === val) {
            return this.$store.getters[OfferPosition.getters.getRemovingOfferPositionAddCosts]
          }
        },
        getRemovingOfferPositionSalesCommission (val) {
          if (this.indexOfferPositionSalesCommissionToDelete === val) {
            return this.$store.getters[OfferPosition.getters.getRemovingOfferPositionCommission]
          }
        },
        getRemovingOfferPositionDiscount (val) {
          if (this.indexOfferPositionDiscountToDelete === val) {
            return this.$store.getters[OfferPosition.getters.getRemovingOfferPositionDiscount]
          }
        },
        calculateSupplierOfferUnitPriceMethod (val) {
          let unitPrice = val.unit_price
          val.discounts.forEach(function (item) {
            unitPrice -= (unitPrice * (item.value / 100))
          })
          return Intl.NumberFormat('de-DE', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(unitPrice)
        },
        loadAllAccounts () {
          this.$store.dispatch(Settings.actions.loadAllAccounts).then(response => {
            this.allAccounts = response.data.data
          })
        },
        customContactFilter (item, queryText, itemText) {
          const isMatch = (test, query) => {
            return test.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
          }
          const query = queryText || ''
          const displayText = item.title + ' ' + item.firstname + ' ' + item.lastname
          const rc = isMatch(item.firstname, query) ||
                    isMatch(item.lastname, query) ||
                    isMatch(item.email, query) ||
                    isMatch(displayText, query)
          console.log(`filter: ${JSON.stringify(item)}, '${query}', ${JSON.stringify(itemText)} => ${rc}`)
          return rc
        },
        getLoadingDocumentToken (val) {
          return this.loadingOfferForId === val
        },
        openBottomSheet (payload) {
          if (payload) {
            this.$store.dispatch('openCloseBottomSheet')
          }
        },
        editSupplierOffer () {
          this.$store.dispatch(SupplierOffers.actions.openCloseDialog)
        },
        deleteSupplierOffer () {

        },
        openAddSupplierDialog () {
          this.$store.dispatch(SupplierOffers.actions.setSelectedSupplierOffer, null)
          this.$store.dispatch(SupplierOffers.actions.openCloseDialog)
        }

      },
      computed: {
        selectedItem () {
          console.log('selected offer: ' + JSON.stringify(this.$store.getters[Offer.getters.getSelectedOffer]))
          return this.$store.getters[Offer.getters.getSelectedOffer]
        },
        selectedOfferPosition () {
          console.log('selected offer position: ' + JSON.stringify(this.$store.getters[OfferPosition.getters.getSelectedOfferPosition]))
          return this.$store.getters[OfferPosition.getters.getSelectedOfferPosition]
        },
        getDocumentViewToken () {
          return this.$store.getters[SupplierOffers.getters.getSupplierOfferDocumentToken]
        },
        getSupplierOfferPositions () {
          return this.$store.getters[SupplierOfferPositions.getters.getSupplierOfferPositions]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        loadingSupplierOfferPositions () {
          return this.$store.getters[SupplierOfferPositions.getters.getLoadingSupplierOfferPosition]
        },
        getCurrencies () {
          return this.$store.getters[Settings.getters.getAllCurrencies]
        },
        termsOfPayment () {
          return this.$store.getters[Settings.getters.getTermsOfPayments]
        },
        termsOfDelivery () {
          return this.$store.getters[Settings.getters.getTermsOfDeliveries]
        },
        getSelectedSupplierOfferPosition () {
          return this.$store.getters[SupplierOfferPositions.getters.getSelectedSupplierOfferPosition]
        },
        getExchangeRate () {
          if (this.selectedItem.currency.name !== null || typeof this.selectedItem.currency.name === 'undefined') {
            let currency = this.selectedItem.currency.name
            return this.$store.getters[Settings.getters.getExchangeRate].quotes['USD' + currency]
          }
          return 0.00
        },
        calculateExchangePurchasePrice () {
          if (this.getSelectedSupplierOfferPosition.unit_price !== 0 && this.getExchangeRate !== 0) {
            return new Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2

            }).format(in$($(this.getSelectedSupplierOfferPosition.unit_price) * this.getExchangeRate))
          } else {
            return '0,00'
          }
        },
        needExchange () {
          if (this.selectedItem.currency.id !== this.getSelectedSupplierOfferPosition.suppliers_offer.currency.id) {
            return true
          } else {
            return false
          }
        },
        calculateCurrencyMargin () {
          if (this.needExchange) {
            return new Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2

            }).format(((this.calculateSupplierOfferUnitPrice * this.getExchangeRate) / this.selectedOfferPosition.margin) - (this.calculateSupplierOfferUnitPrice * this.getExchangeRate))
          } else {
            return new Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2

            }).format((this.calculateSupplierOfferUnitPrice / this.selectedOfferPosition.margin) - this.calculateSupplierOfferUnitPrice)
          }
        },
        calculateRealCurrencyMargin () {
          return new Intl.NumberFormat('de-DE', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2

          }).format(this.calculateSupplierOfferUnitSalesPrice - this.calculateSupplierOfferUnitSalesPriceWithAC)
        },
        getDeliveryTimeTypes () {
          return this.$store.getters[Settings.getters.getAllDeliveryTimeTypes]
        },
        calculateTotalSalesPrice () {
          this.selectedOfferPosition.unit_sales_price = this.calculateSupplierOfferUnitSalesPrice
          this.selectedOfferPosition.total_sales_price = in$($(this.selectedOfferPosition.unit_sales_price) * this.selectedOfferPosition.quantity)
          return Intl.NumberFormat('de-DE', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(this.selectedOfferPosition.total_sales_price)
        },
        calculateSupplierOfferUnitSalesPrice () {
          let unitPrice = 0

          if (this.needExchange) {
            unitPrice = in$(($(this.calculateSupplierOfferUnitPrice) / this.selectedOfferPosition.margin) * this.getExchangeRate)
          } else {
            unitPrice = in$($(this.calculateSupplierOfferUnitPrice) / this.selectedOfferPosition.margin)
          }

          this.selectedOfferPosition.customers_offers_positions_additional_costs.forEach(function (item) {
            if (item.type === 'fixed') {
              unitPrice = $$(
                            $(unitPrice),
                            $(item.value)
                        ).$
            } else {
              unitPrice = $$(
                            $(unitPrice),
                            addPercent(item.value)
                        ).$
            }
          })
          this.selectedOfferPosition.customers_offers_positions_commissions.forEach(function (item) {
            unitPrice = $$(
                        $(unitPrice),
                        addPercent(item.value)
                    ).$
          })
          this.selectedOfferPosition.customers_offers_positions_discounts.forEach(function (item) {
            unitPrice = $$(
                        $(unitPrice),
                        subtractPercent(item.value)
                    ).$
          })

          return unitPrice
        },
        calculateSupplierOfferUnitSalesPriceWithAC () {
          let unitPrice = 0

          if (this.needExchange) {
            unitPrice = in$(($(this.calculateSupplierOfferUnitPrice)) * this.getExchangeRate)
          } else {
            unitPrice = in$($(this.calculateSupplierOfferUnitPrice))
          }

          this.selectedOfferPosition.customers_offers_positions_additional_costs.forEach(function (item) {
            if (item.type === 'fixed') {
              unitPrice = $$(
                $(unitPrice),
                $(item.value)
              ).$
            } else {
              unitPrice = $$(
                $(unitPrice),
                addPercent(item.value)
              ).$
            }
          })
          return unitPrice
        },
        calculateSupplierOfferUnitSalesPriceWithACFormatted () {
          return Intl.NumberFormat('de-DE', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(this.calculateSupplierOfferUnitSalesPriceWithAC)
        },
        calculateSupplierOfferUnitSalesPriceFormatted () {
          return Intl.NumberFormat('de-DE', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(this.calculateSupplierOfferUnitSalesPrice)
        },
        calculateSupplierOfferUnitPriceFormatted () {
          return Intl.NumberFormat('de-DE', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(this.calculateSupplierOfferUnitPrice)
        },
        calculateSupplierOfferUnitPrice () {
          let unitPrice = this.getSelectedSupplierOfferPosition.unit_price
          this.getSelectedSupplierOfferPosition.discounts.forEach(function (item) {
            unitPrice = $$(
                        $(unitPrice),
                        subtractPercent(item.value)
                    ).$
          })
          return unitPrice
        },
        calculateUnitProv () {
          let prov = {
            percent: 0,
            price: 0
          }

          if (this.needExchange) {
            prov.price = Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format($$(
                        $(this.calculateSupplierOfferUnitSalesPrice),
                        $(-in$($(this.calculateSupplierOfferUnitPrice * this.getExchangeRate)))
                    ).$)

            prov.percent = Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(((100 / in$($(this.calculateSupplierOfferUnitPrice * this.getExchangeRate))) * this.calculateSupplierOfferUnitSalesPrice) - 100)

            return prov
          } else {
            prov.price = Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format($$(
                        $(this.calculateSupplierOfferUnitSalesPrice),
                        $(-this.calculateSupplierOfferUnitPrice)
                    ).$)

            prov.percent = Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(((100 / this.calculateSupplierOfferUnitPrice) * this.calculateSupplierOfferUnitSalesPrice) - 100)

            return prov
          }
        },
        calculateTotalProv () {
          let prov = {
            percent: 0,
            price: 0
          }

          if (this.needExchange) {
            prov.price = Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format($$(
                        $(in$($(this.calculateSupplierOfferUnitSalesPrice * this.selectedOfferPosition.quantity))),
                        $(-in$($(this.calculateSupplierOfferUnitPrice * this.getExchangeRate) * this.selectedOfferPosition.quantity))
                    ).$)

            prov.percent = Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(((100 / (in$($(this.calculateSupplierOfferUnitPrice * this.getExchangeRate) * this.selectedOfferPosition.quantity))) * in$($(this.calculateSupplierOfferUnitSalesPrice) * this.selectedOfferPosition.quantity)) - 100)

            return prov
          } else {
            prov.price = Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format($$(
                        $((this.calculateSupplierOfferUnitSalesPrice * this.selectedOfferPosition.quantity)),
                        $(-(this.calculateSupplierOfferUnitPrice * this.selectedOfferPosition.quantity))
                    ).$)

            prov.percent = Intl.NumberFormat('de-DE', {
              style: 'decimal',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(((100 / (this.calculateSupplierOfferUnitPrice * this.selectedOfferPosition.quantity)) * (this.calculateSupplierOfferUnitSalesPrice * this.selectedOfferPosition.quantity)) - 100)

            return prov
          }
        },
        supplierOfferDialog () {
          return this.$store.getters[SupplierOffers.getters.getOpenDialogState]
        }

      },
      watch: {
        getSelectedSupplierOfferPosition: {
          handler () {
            console.log('getSelectedSupplierOfferPosition' + this.calculateSupplierOfferUnitSalesPrice)
          },
          deep: true
        },
        saveCalculationValidation: {
          handler (val) {
            console.log('saveCalculationValidation: ' + val)
          },
          deep: true
        },
        selectedOfferPosition: {
          handler () {
            this.$refs.form.validate()
          },
          deep: true
        },
        supplierOfferDialog: {
          handler (val) {
            if (!val) {
              this.loadSupplierOffers()
            }
          },
          deep: true
        }
      },
      filters: {
        toDateOnly: function (value) {
          if (!value) return ''
          if (value) {
            return moment(String(value)).format('DD.MM.YYYY')
          }
        }
      }

    }
</script>


<style scoped>

    #menu-button {
        margin: 0px;
        margin-right: 8px;
        width: 25px;
        height: 25px;
    }

    .fromTop {
        padding-top: 120px;
    }

    .fixSides::before {
        position: absolute;
        content: "";
        background-color: #1e336d;
        height: 100%;
        width: 110vw;
        top: 0px;
        left: -24px;
    }

    .overflow-hidden {
        overflow: hidden;
    }

    .horiz-scroll {
        overflow-y: hidden;
        overflow-x: auto;
    }

    .pdfbutton {
        margin-right: 0px;
    }


</style>



// WEBPACK FOOTER //
// src/components/Offers/OfferPositions/CalculateOfferPosition.vue